import { render, staticRenderFns } from "./potential.vue?vue&type=template&id=60910295&"
import script from "./potential.vue?vue&type=script&lang=js&"
export * from "./potential.vue?vue&type=script&lang=js&"
import style0 from "./potential.vue?vue&type=style&index=0&id=60910295&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports